import { FEATURE_CARDS } from '@/data/indexSections';

export function FeaturesSection() {
  return (
    <section id="plan" aria-labelledby="features-title" className="bg-surface-muted">
      <div className="inner flex h-[858px] flex-col justify-center">
        <header className="reveal mb-16">
          <img
            src="/assets/images/logo-nova.png"
            alt="Nova"
            width="720"
            height="208"
            className="mb-5 h-11 w-auto"
            loading="lazy"
          />
          <h2 id="features-title" className="heading-2">
            침해사고 대응의
            <br className="br-mobile" /> 새로운 기준이 됩니다.
          </h2>
        </header>

        <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-4" role="list">
          {FEATURE_CARDS.map((card) => (
            <li key={card.icon} className="feature-card reveal">
              <img
                src={`/assets/icons/${card.icon}.png`}
                alt=""
                aria-hidden="true"
                width={card.width}
                height="176"
                className="feature-card-icon"
                loading="lazy"
              />
              <div>
                <h3 className="feature-card-title">{card.title}</h3>
                <p className="feature-card-desc">{card.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
